module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAKUlEQVRIx2Ng0K7Hg/5cFMODzgmq4UEMo0aPGj1q9KjRo0aPGj0UjQYAXzHKL165l44AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ro.png
// module id = 910
// module chunks = 0